import React, { useEffect, useState } from "react";
import { Button, Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { BrowserView, MobileView } from "react-device-detect";


import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";

import clone from "lodash-es/clone";

import { showSuccess, showToast } from "../../components/ATPDialogs";
import {
  getCourseDate,
  getCourseDateStudents,
  updateCourseAttendance
} from "../../services/CourseService";

import { hasError, getError } from "../../services/ServiceHelper";
import "../../ResponsiveTable.css";
import CourseDetails from "../../components/faculty/CourseDetails";

const CourseTakeAttendance = () => {

  const [_school] = useLocalStorage("Auth", "school", null);
  const { courseDateEid } = useParams();

  const [_jwt] = useJwtStorage();
  const [_courseDateDetails, setCourseDateDetails] = useState({
    attendees: [],
  });

  const [_courseDate, setCourseDate] = useState(null);
  const [showProgress, setShowProgress] = useState(false);

  // captures students that need to be updated
  const [_mapQueue, setMapQueue] = useState({});
  const [_attendanceTakenDate, setAttendanceTakenDate] = useState(null);
  const [_attendanceTaken, setAttendanceTaken] = useState(0);
  const [_attendanceTakenStatusText, setAttendanceTakenStatusText] =
    useState(null);

  useEffect(() => {
    initCourseDate();
    initCourseDateStudents();
  }, []);

  const initCourseDateStudents = () => {
    setShowProgress(true);
    getCourseDateStudents(_school, _jwt, courseDateEid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to get Course Date Students: ",
            getError(results)
          );
          return;
        }

        // attach a few extra attributes for each student
        for (let student of results.data.attendees) {
          student.pointChecked = false;
        }

        setCourseDateDetails(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
        setShowProgress(false);

      });
  };

  const initCourseDate = () => {
    getCourseDate(_school, _jwt, courseDateEid)
      .then((results) => {
        if (hasError(results) === true) {
          showToast("E", "Unable to get Course: ", getError(results));
          return;
        }
        setCourseDate(results.data);
      })
      .catch((error) => {
        console.log("ERROR:");
        console.log(error);
      })
      .finally(() => {
      });
  };

  const handleChangeAllPresentModify = (event) => {
    const checked = event.target.checked;
    const courseDateDetails = clone(_courseDateDetails);

    for (let student of courseDateDetails.attendees) {
      student.is_present = checked;
      student.is_late = false;
      evalStudentStatus(student);
    }

    setCourseDateDetails(courseDateDetails);
  };

  const handleChangePresentModify = (event, userEid) => {
    const checked = event.target.checked;
    const courseDateDetails = clone(_courseDateDetails);

    // clone and find
    console.log('here:' + userEid);
    for (const student of courseDateDetails.attendees) {
      if (student.user_eid === userEid) {
        console.log('found');
        student.is_present = checked;
        evalStudentStatus(student);
        break;
      }
    }
    setCourseDateDetails(courseDateDetails);
  };


  const handleChangeLateModify = (event, userEid) => {
    const checked = event.target.checked;
    const courseDateDetails = clone(_courseDateDetails);

    // clone and find
    for (const student of courseDateDetails.attendees) {
      if (student.user_eid === userEid) {
        student.is_late = checked;
        evalStudentStatus(student);
        break;
      }
    }
    setCourseDateDetails(courseDateDetails);
  };

  const evalStudentStatus = (student) => {
    let status = "";

    if (student.is_late) {
      status = "late";
    } else {
      if (student.is_present) {
        status = "present";
      } else {
        status = "absent";
      }
    }

    const mapQueue = clone(_mapQueue);
    mapQueue[student.user_eid] = status;
    setMapQueue(mapQueue);
  };

  const updateAttendanceStatus = (taken, date) => {
    let html = "";
    if (taken === 0) {
      html = "Attendance NOT Taken/Saved Yet";
    } else {
      html = "Attendance taken";

      if (date != null) {
        html +=
          " on " +
          date.toLocaleDateString("en-US") +
          " at " +
          date.toLocaleTimeString("en-US");
      }
    }

    setAttendanceTakenStatusText(html);
  };

  const updateDeltaAttendance = () => {
    const queueLength = Object.keys(_mapQueue).length;
    const attendanceTakenDate = new Date();

    // update for UI
    setAttendanceTakenDate(attendanceTakenDate);
    setAttendanceTaken(1);
    updateAttendanceStatus(1, attendanceTakenDate);

    if (queueLength === 0) {
      showSuccess("Saved Attendance", "Attendance has been saved (0).");
      return;
    }
    // unlike regular attendance, these are just deltas
    const presentEids = [];
    const absentEids = [];
    const lateEids = [];
    Object.keys(_mapQueue).forEach(function (userEid) {
      // skip skunkers
      if (userEid.length <= 1) {
        return;
      }
      if (_mapQueue[userEid] === "present") {
        presentEids.push(userEid);
      } else if (_mapQueue[userEid] === "absent") {
        absentEids.push(userEid);
      } else if (_mapQueue[userEid] === "late") {
        lateEids.push(userEid);
      }
    });
    setShowProgress(true);
    updateCourseAttendance(
      _school,
      _jwt,
      courseDateEid,
      presentEids,
      lateEids,
      absentEids
    )
      .then((results) => {
        if (hasError(results) === true) {
          showToast(
            "E",
            "Unable to Update Course Attendance: ",
            getError(results)
          );
          return;
        }
        setMapQueue({});
        showToast("S", "Attendance Updated");
    })
    .catch((error) => {
      console.log("ERROR:");
      console.log(error);
    })
    .finally(() => {
      setShowProgress(false);
    });
  };

  const handleClickSave = () => {
    updateDeltaAttendance();
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Course Attendance" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <BrowserView>
          <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
            <span className="emphasis">INSTRUCTIONS</span> - Mark the Students
            who are in attendance, and click one the SAVE buttons below.
          </Alert>

          {_courseDate != null && _courseDate.attendanceTakenDate == null && (
            <Alert severity="warning" sx={{ mt: 1, mb: 1 }}>
              Attendance NOT marked as taken for this course. Please click SAVE.
            </Alert>
          )}
        </BrowserView>

        {_courseDate != null && (
          <Box sx={{ boxShadow: 1, p: 1, mt: 0 }}>
            <CourseDetails school={_school} courseDetails={_courseDate} />
          </Box>
        )}

        <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
          <SubTitle text="Student List" sx={{ mt: 0 }} />

          <Button
            key="save1"
            onClick={handleClickSave}
            sx={{ ml: 0 }}
            color="success"
            variant="contained"
          >
            SAVE
          </Button>
          <br />

          <FormControlLabel
            control={
              <Checkbox
                onChange={(event) => handleChangeAllPresentModify(event)}
              />
            }
            label="Select All Present"
          />

          <BrowserView>
            <Table>
              <Thead>
                <Tr>
                  <Th>
                    <div className="textCenter">Present?</div>
                  </Th>
                  <Th>
                    <div className="textCenter">Late?</div>
                  </Th>
                  <Th>Student Name</Th>
                </Tr>
              </Thead>
              <Tbody>
                {_courseDateDetails.attendees.map((student) => (
                  <Tr key={student.user_eid}>
                    <Td>
                      <div className="textCenter">
                        <Checkbox
                          sx={{ pt: 0 }}
                          checked={student.is_present}
                          className="chkPresent"
                          onChange={(event) =>
                            handleChangePresentModify(
                              event,
                              student.user_eid
                            )
                          }
                        />
                      </div>
                    </Td>
                    <Td>
                      <div className="textCenter">
                        <Checkbox
                          sx={{ pt: 0 }}
                          checked={student.is_late}
                          className="chkLate"
                          onChange={(event) =>
                            handleChangeLateModify(
                              event,
                              student.user_eid
                            )
                          }
                        />
                      </div>
                    </Td>
                    <Td>
                      <div className="emphasis">
                        {student.last_name}, {student.first_name} (
                        {student.grade})
                      </div>
                      {student.email}
                    </Td>
                  </Tr>
                ))}
                {_courseDateDetails.attendees.length === 0 && (
                  <Tr>
                    <Td colSpan={6}>-- NO ATTENDEES --</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </BrowserView>

          <MobileView>
            <table
              style={{
                width: "100%",
                paddingLeft: "0.5em",
                paddingBottom: "0.5em",
                paddingTop: "0.5em",
                backgroundColor: "#f0f0f0",
              }}
            >
              <thead>
                <tr>
                  <th>Pre?</th>
                  <th>Lt?</th>
                  <th style={{ textAlign: "left" }}>Student</th>
                </tr>
              </thead>
              <tbody>
                {_courseDateDetails.attendees.map((student) => (
                  <tr>
                    <td style={{ textAlign: "center" }}>
                      <Checkbox
                        sx={{ pt: 0, pl: 1 }}
                        checked={student.is_present}
                        className="chkPresent"
                        onChange={(event) =>
                          handleChangePresentModify(
                            event,
                            student.user_eid
                          )
                        }
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <Checkbox
                        sx={{ pt: 0, pl: 1 }}
                        checked={student.is_late}
                        className="chkLate"
                        onChange={(event) =>
                          handleChangeLateModify(
                            event,
                            student.user_eid
                          )
                        }
                      />
                    </td>
                    <td style={{ verticalAlign: "top" }}>
                      {student.last_name}, {student.first_name}
                    </td>
                  </tr>
                ))}
                {_courseDateDetails.attendees.length === 0 && (
                  <tr>
                    <td colSpan={6}>-- NO ATTENDEES --</td>
                  </tr>
                )}
              </tbody>
            </table>
          </MobileView>

          <Button
            key="save2"
            onClick={handleClickSave}
            sx={{ ml: 0, mt: 2 }}
            color="success"
            variant="contained"
          >
            SAVE
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default CourseTakeAttendance;
